










import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class DadosNumero extends Vue {
    get numero () {
        return this.$store.state.cotacao.numero;
    }

    set numero ( value ) {
        this.$store.commit("SET_NUMERO", value);
    }

    get errorNumero () {
        return this.$store.state.errors.numero;
    }

    public onChange () {
        this.$store.dispatch("VALIDAR_DADOS")
            .then()
            .catch(() => { return; });
    }
}
